<div class="flex flex-col h-full">
  <div
    class="external-main-content items-center justify-center flex-1 p-6 text-center sm:px-20 md:px-24 md:py-8 dark:text-white bg-grey-FA dark:bg-box-dark"
  >
    <div class="modal-body action-modal-body">
      <div class="modal-content">
        <img
          [src]="logoPath"
          [alt]="mission?.mission_logo_alt_text"
          class="logo"
        />
        <h2
          class="text-2xl font-semibold lg:font-bold lg:text-3xl"
          [innerHTML]="title | markdown2html : { secure: true }"
        ></h2>
        <p
          [innerHTML]="description | convertMarkdownToHtml"
          class="text-xl font-medium my-6 lg:text-2xl"
        ></p>
        <div
          class="time-to-answer-section"
          *ngIf="
            isShowTimeOnTileFlagOn &&
            mission?.mission_kind !== missionKind.standard &&
            timeToAnswer &&
            !isPreview
          "
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="stopwatch">
              <path
                id="&#240;&#159;&#140;&#136; COLOR"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.3 8.58811L19.21 7.68811C19.6021 7.29598 19.6021 6.66023 19.21 6.26811C18.8179 5.87598 18.1821 5.87598 17.79 6.26811L16.89 7.17811C14.0076 4.94829 9.98245 4.94829 7.10003 7.17811L6.19003 6.25811C5.79514 5.86598 5.15715 5.86822 4.76503 6.26311C4.3729 6.65799 4.37514 7.29598 4.77003 7.68811L5.69003 8.59811C4.59304 9.99565 3.99782 11.7215 4.00003 13.4981C3.99106 17.0016 6.26274 20.1033 9.60562 21.1519C12.9485 22.2005 16.5848 20.9519 18.5784 18.071C20.5721 15.1901 20.4593 11.3471 18.3 8.58811ZM12 19.4979C8.68632 19.4979 6.00003 16.8116 6.00003 13.4979C6.00003 10.1842 8.68632 7.49792 12 7.49792C15.3137 7.49792 18 10.1842 18 13.4979C18 15.0892 17.3679 16.6153 16.2427 17.7406C15.1174 18.8658 13.5913 19.4979 12 19.4979ZM10 4.49805H14C14.5523 4.49805 15 4.05033 15 3.49805C15 2.94576 14.5523 2.49805 14 2.49805H10C9.44774 2.49805 9.00003 2.94576 9.00003 3.49805C9.00003 4.05033 9.44774 4.49805 10 4.49805ZM13 10.4982C13 9.94588 12.5523 9.49817 12 9.49817C11.4477 9.49817 11 9.94588 11 10.4982V12.3882C10.5365 12.8028 10.3769 13.4605 10.5988 14.0414C10.8207 14.6224 11.3781 15.0062 12 15.0062C12.622 15.0062 13.1794 14.6224 13.4013 14.0414C13.6232 13.4605 13.4636 12.8028 13 12.3882V10.4982Z"
                fill="currentColor"
              />
            </g>
          </svg>
          <span class="text-sm font-medium"
            >{{ 'specialTile.averageSurveyTime' | translate }}:
            {{ timeToAnswer }}
            {{ returnMinuteOrMinutes() | translate }}</span
          >
        </div>

        <button
          class="animation-submit-btn"
          (click)="getStarted()"
          [attr.data-track]="'member-external-beginning-get-started'"
          [ngClass]="{
            primarySection: !isLoading,
            loadingSection: isLoading
          }"
          [disabled]="isLoading"
        >
          <div class="primaryTitle" *ngIf="!isLoading">
            {{ 'general.getStarted' | translate }}
          </div>
          <div class="loadingTitle" *ngIf="isLoading">
            {{ 'general.loading' | translate }}
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
